if (!customElements.get('klaviyo-review-modal')) {
  const KLAVIYO_REVIEWS_ORIGIN = 'https://reviews-app.services.klaviyo.com';

  customElements.define('klaviyo-review-modal', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.frame = this.querySelector('iframe');

      this.querySelector('.js-klaviyo-review-open').addEventListener('click', () => this.open());
      this.querySelector('.js-klaviyo-review-close').addEventListener('click', () => this.dialog.close());
      // Clicks on the backdrop land on the <dialog> itself rather than its contents.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));

      // Klaviyo's form posts "close" from its own close button, normally handled by its widget script.
      this.onMessage = (event) => {
        if (event.origin !== KLAVIYO_REVIEWS_ORIGIN || event.source !== this.frame.contentWindow) return;
        if (event.data === 'close') this.dialog.close();
      };
      window.addEventListener('message', this.onMessage);
    }

    disconnectedCallback() {
      window.removeEventListener('message', this.onMessage);
      document.body.classList.remove('overflow-hidden');
    }

    open() {
      if (!this.frame.getAttribute('src')) this.frame.src = this.frame.dataset.src;
      this.dialog.showModal();
      document.body.classList.add('overflow-hidden');
    }
  });
}

if (!customElements.get('product-reviews-list')) {
  customElements.define('product-reviews-list', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.js-show-more');
      if (!this.button) return;

      this.batchSize = Number(this.dataset.batchSize) || 5;
      this.button.addEventListener('click', () => this.showMore());
    }

    showMore() {
      const collapsed = this.querySelectorAll('.product-reviews-seo__review--collapsed');

      Array.from(collapsed)
        .slice(0, this.batchSize)
        .forEach((review) => review.classList.remove('product-reviews-seo__review--collapsed'));

      if (collapsed.length <= this.batchSize) this.button.parentElement.remove();
    }
  });
}
